import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../../features/admin/customer-management/customer/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.customermanagement.customers);

  const [first_name, setName] = useState("");
  const [last_name, setlastname] = useState("");
  const [email, setemail] = useState("");
  const [contact_no, setcontact_no] = useState("");
  

  useEffect(() => {
    fetch();
  }, [first_name,last_name,email, contact_no]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAll({
        first_name,
        last_name,
        email,
        contact_no,
        page,
        per_page: country?.per_page,
      })
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      await fetch();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return {
    country,
    first_name,
    setName,
    last_name, 
    setlastname,
    email, 
    setemail,
    contact_no, 
    setcontact_no,
    fetch,
    // deleteData,
    toggleStatus,
  };
};
